import { useState } from 'react';
import { API_ENDPOINTS } from '../../config/constants';
import { generateToken, TOKEN_HEADER } from '../../utils/tokenUtils';

function HomeNewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('Subscribing...');
    try {
      const normalizedEmail = email.trim();
      const res = await fetch(API_ENDPOINTS.NEWSLETTER_SUBSCRIBE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', [TOKEN_HEADER]: generateToken() },
        body: JSON.stringify({ email: normalizedEmail, name: normalizedEmail }),
      });
      if (res.ok) {
        setStatus("You're in! Welcome to the newsletter.");
        setEmail('');
      } else {
        setStatus('Something went wrong. Please try again.');
      }
    } catch {
      setStatus('Something went wrong. Please try again.');
    }
  };

  return (
    <section className="band news" id="newsletter" aria-labelledby="newsletter-title">
      <div className="wrap">
        <h2 id="newsletter-title">Join the Lead With Tech Newsletter</h2>
        <p>Frameworks, AI engineering tactics and career moves - delivered to engineers who are serious about leading. No fluff.</p>
        <form className="news-form" onSubmit={handleSubmit} noValidate>
          <input
            type="email"
            placeholder="you@company.com"
            aria-label="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button className="btn btn-red" type="submit">Subscribe</button>
        </form>
        {status && <p className="news-note">{status}</p>}
        {!status && <div className="news-note">One email a week. Unsubscribe anytime.</div>}
      </div>
    </section>
  );
}

export default HomeNewsletterSection;
